export default function () {
  return {
    firstName: undefined,
    lastName: undefined,
    email: undefined,
    creatingUser: false,
    createUserError: undefined,
    pin: undefined,
    pinAllowedAttempts: undefined,
    pinAttempts: undefined,
    sendingSignUpPin: false,
    resendingSignUpPin: false,
    signUpPinError: undefined,
    signUpPinFailureReason: undefined
  };
}
